import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { flowRight as compose } from 'lodash';
import { graphql } from 'react-apollo';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../components/Common/Loader/Loader';

import messages from '../../../locale/messages';
import getContentPageById from './getContentPageById.graphql';

import s from './EditContentPage.css';

export class EditContentPage extends Component {

    static propTypes = { id: PropTypes.number.isRequired }

    constructor(props) {
        super(props)
        this.component = null;
    }

    componentDidMount() {
        if (typeof window !== 'undefined' && typeof document !== undefined) {
            this.component = require('../../../components/SiteAdmin/ContentPage/AddContentPageForm').default
        }
    }

    render() {
        const { getContentPageById: { getContentPageById, loading }, intl: { formatMessage } } = this.props;
        const isBrowser = typeof window !== 'undefined';
        const isDocument = typeof document !== undefined;
        const AddContentPageForm = this.component;

        let initialValues = {};

        if (!loading && getContentPageById && getContentPageById.result) {
            initialValues = {
                id: getContentPageById.result.id,
                metaTitle: getContentPageById.result.metaTitle,
                metaDescription: getContentPageById.result.metaDescription,
                pageUrl: getContentPageById.result.pageUrl,
                pageTitle: getContentPageById.result.pageTitle,
                isEnable: getContentPageById.result.isEnable,
                pageBanner: getContentPageById.result.pageBanner,
            }

            if (getContentPageById?.result?.dynamicContentDetails?.length > 0) {
                initialValues['content'] = getContentPageById?.result?.dynamicContentDetails?.map((item) => ({
                    language: item?.language,
                    content: item?.content
                }))
            }
        }

        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    <div className={s.container}>
                        <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}> {formatMessage(messages.contentpageManagement)}</div>
                        <div className={s.paddingRoutesSection}>
                            {!loading && isBrowser && isDocument && <AddContentPageForm initialValues={initialValues} />}
                        </div>
                    </div>
                </div>
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withStyles(s),
    graphql(getContentPageById, {
        name: 'getContentPageById',
        options: (props) => ({
            ssr: true,
            variables: {
                id: props.id,
            },
            fetchPolicy: 'network-only'
        })
    })
)(EditContentPage)
